import { useMemo, useState } from 'react';

import { ELoginMethods } from '@/lib/enums';
import { useAppState } from '@/state/hooks/app.state.hook';
import { useLoginState } from '@/state/hooks/login.state.hook';
import { LoginButton, LoginInput } from '@/components/portal-ui';
import { FindYourUsername } from '../Components/FindYourUsername';

import { useTranslations } from 'next-intl';

export const UsernamePasswordMode: React.FC = () => {
  const t = useTranslations();
  const { hasConsent, loginResponse, setLoginType, setIsLoggingIn } = useLoginState();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');

  const { initialBoot } = useAppState();
  const theme = initialBoot?.theme;

  const isDisabled = useMemo(
    () => !username.trim().length || !password.trim().length || !hasConsent,
    [username, password, hasConsent]
  );

  const handleFormSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    if (isDisabled) return;
    loginResponse({
      authMethod: ELoginMethods.USERNAME,
      userName: username,
      userPassword: password
    });
  };

  return (
    <div className='flex flex-col items-center justify-center gap-6'>
      <form onSubmit={handleFormSubmit} className='flex w-full flex-col gap-4'>
        <LoginInput
          type='text'
          placeholder={t('portal.login.username')}
          value={username}
          setValue={setUsername}
        />
        <LoginInput
          type='password'
          placeholder={t('portal.login.password')}
          value={password}
          setValue={setPassword}
        />
        <FindYourUsername />
        <LoginButton
          type='submit'
          variant='white'
          text={t('portal.login.login')}
          isDisabled={isDisabled}
        />
      </form>
      <button
        className='text-center text-sm'
        style={{ color: theme?.loginPopup?.fontColor || '#FFF' }}
        onClick={() => {
          setLoginType(null);
          setIsLoggingIn(false);
        }}
        type='button'>
        {t('portal.login.back')}
      </button>
    </div>
  );
};
